import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function WarningIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="37" height="32" viewBox="0 0 37 32"  {...props}>
      <g>
        <g fill="none">
          <path 
            d="M16.769 2.995a2 2 0 0 1 3.463 0L35.265 29a2 2 0 0 1-1.731 3H3.466a2 2 0 0 1-1.731-3z"
            transform="translate(-823 -403) translate(823 403)"
          />
          <path
            fill="currentColor"
            d="M18.5 3.746c-.144 0-.199.094-.216.125L3.25 29.875c-.018.03-.072.125 0 .25s.18.125.216.125h30.068c.035 0 .144 0 .216-.125.072-.125.018-.22 0-.25L18.716 3.87c-.017-.031-.072-.125-.216-.125m0-1.75c.673 0 1.346.333 1.731.999l15.034 26.004c.77 1.333-.191 3.001-1.731 3.001H3.466c-1.54 0-2.502-1.668-1.731-3.001L16.769 2.995c.385-.666 1.058-.999 1.731-.999z"
            transform="translate(-823 -403) translate(823 403)"
          />
        </g>
        <text fill="currentColor" fontFamily="Roboto-Regular, Roboto" fontSize="20px" transform="translate(-823 -403) translate(839 430)">
          <tspan x="0" y="0">!</tspan>
        </text>
      </g>
    </SvgIcon>
  )
}

export default WarningIcon;


// WEBPACK FOOTER //
// ./src/components/icons/WarningIcon.jsx